export default [
    {
        path: '*',
        redirect: { name: 'products' },
        component: require('@views/notfound').default,
    },
]
